/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { AwardCupIcon16Light } from './AwardCupIcon16Light';
import { AwardCupIcon16Regular } from './AwardCupIcon16Regular';
import { AwardCupIcon16Solid } from './AwardCupIcon16Solid';
import { AwardCupIcon20Light } from './AwardCupIcon20Light';
import { AwardCupIcon20Regular } from './AwardCupIcon20Regular';
import { AwardCupIcon20Solid } from './AwardCupIcon20Solid';
import { AwardCupIcon24Regular } from './AwardCupIcon24Regular';
import { AwardCupIcon24Solid } from './AwardCupIcon24Solid';
import { AwardCupIcon32Regular } from './AwardCupIcon32Regular';
import { AwardCupIcon64Regular } from './AwardCupIcon64Regular';
var sizes = {
    16: {
        light: AwardCupIcon16Light,
        regular: AwardCupIcon16Regular,
        solid: AwardCupIcon16Solid,
    },
    20: {
        light: AwardCupIcon20Light,
        regular: AwardCupIcon20Regular,
        solid: AwardCupIcon20Solid,
    },
    24: {
        regular: AwardCupIcon24Regular,
        solid: AwardCupIcon24Solid,
    },
    32: {
        regular: AwardCupIcon32Regular,
    },
    64: {
        regular: AwardCupIcon64Regular,
    },
};
export var AwardCupIcon = forwardRef('AwardCupIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
